<div class="fc-tooltip-wrapper"
    [ngClass]="[position]"
    [class.visible]="visible"
    [style.left]="left + 'px'"
    [style.top]="top + 'px'">
    <ng-container *ngIf="isTemplateRef(content); else stringContent">
        <div class="fc-tooltip-container-template" [ngClass]="[tooltipClass]" (click)="$event.stopPropagation()">
            <ng-container *ngTemplateOutlet="content; context: { data: data }"></ng-container>
        </div>
    </ng-container>
    <ng-template #stringContent>
        <div class="fc-tooltip-container" [ngClass]="[tooltipClass]" (click)="$event.stopPropagation()">
            <span class="fc-tooltip-text" [innerHTML]="content"></span>
        </div>
    </ng-template>
</div>